import axios from "../../utils/axiosConfig";
function removeSpacesFromUrl(url: string): string {
  const urlComponents = url.split("/");
  for (let i = 0; i < urlComponents.length; i++) {
    urlComponents[i] = urlComponents[i].replace(/\s/g, "");
  }
  return urlComponents.join("/");
}
axios.defaults.withCredentials = true;

const getComponents = async (clinicId: string) => {
  const url =  `/api/component/user/all?clinic_id=${clinicId}`;
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};

const getAllComponents = async () => {
  const url =  "/api/component/all";
  const modifiedUrl = removeSpacesFromUrl(url);
  const { data } = await axios.get(modifiedUrl);
  return data;
};


const componentsService = {
  getAllComponents,
  getComponents,
};

export default componentsService;
